// Web-compatible types using basic syntax
export const AvatarGradientColor = {
  Red: "Red",
  Blue: "Blue",
  Gold: "Gold",
};

export const AvatarSparklePosition = {
  Left: "Left",
  Right: "Right",
};

export const AvatarLevelPosition = {
  TopRight: "TopRight",
  MiddleRight: "MiddleRight",
};
